import { Page } from "@/models/page-models/Page";

export const LoadingManifestView: Page = {
  "path": "loading-manifest-view",
  "name": "Loading Manifest",
  "props": {
    "data": {
      "title": "Loading Manifest",
      "printable": "FALSE",
      "url": "loading-manifest-view",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Create Loading Manifest",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "createLoadingManifest",
                        "type": "fnRedirect",
                        "arg1Key": "redirectUrl",
                        "arg1Value": "/create-loading-manifest"
                      },
                      "name": "createLoadingManifest"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary"
                }
              ],
              "showIf": "fn(MATCH_ROLE,CUSTOMER_SERVICE_MANAGER)"
            }
          ],
          "type": "genericGroup"
        },
        {
          "type": "tabs",
          "tabItems": [
            {
              "tabName": "Pending",
              "bracketValueFormula": "{{fetchedData.pendingLms.data.totalDocs}}",
              "showIf": "fn(LENGTH,,{{{{fetchedData.pendingLms.data.totalDocs}})",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Pending Loading Manifests",
                      "disabled": "FALSE",
                      "items": "fetchedData.pendingLms.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "LM#",
                          "type": "url",
                          "url": "/loading-manifest/{{__item._id}}"
                        },
                        {
                          "value": "__item.createdAt",
                          "text": "LM Date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.createdAt}})"
                        },
                        {
                          "value": "orders.0.factoryTicket.order.customer",
                          "text": "Customer",
                          "formula": "fn(HELPER_FN,customerAlias,fn(CONDITIONAL,fn(NOT,{{__item.orders.0.factoryTicket.order.customer}}),{{__item.callOffs.0.callOff.customer}},{{__item.orders.0.factoryTicket.order.customer}}))"
                        },
                        {
                          "value": "invoice",
                          "text": "Invoice#", "type": "url",
                          "url": "/invoice/{{__item.invoice}}"
                        },
                        {
                          "value": "__item.typeOfDelivery",
                          "text": "Type of Delivery"
                        },
                        {
                          "value": "__item.driverName",
                          "text": "Driver Name"
                        },
                        {
                          "value": "__item.plateNumber",
                          "text": "Plate No."
                        },
                        {
                          "value": "trackingNo",
                          "text": "Tracking No"
                         }
                      ],
                      "tableType": "static",
                      "neverHideActionBar": true,
                      "pagination": {
                        "pageVariable": "fetchedData.pendingLmForm.page",
                        "serverItemsLengthVariable": "fetchedData.pendingLms.data.totalDocs",
                        "pageChangeFns": [
                          {
                            "executionOrder": 2,
                            "name": "getPendingLms"
                          }
                        ],
                        "itemsPerPageVariable": "fetchedData.pendingLmForm.limit"
                      }
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "Invoiced",
              "bracketValueFormula": "{{fetchedData.invoicedLms.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Invoiced Loading Manifests",
                      "disabled": "FALSE",
                      "items": "fetchedData.invoicedLms.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "LM#",
                          "type": "url",
                          "url": "/loading-manifest/{{__item._id}}"
                        },
                        {
                          "value": "__item.createdAt",
                          "text": "LM Date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.createdAt}})"
                        },
                        {
                          "value": "orders.0.factoryTicket.order.customer",
                          "text": "Customer",
                          "formula": "fn(HELPER_FN,customerAlias,fn(CONDITIONAL,fn(NOT,{{__item.orders.0.factoryTicket.order.customer}}),{{__item.callOffs.0.callOff.customer}},{{__item.orders.0.factoryTicket.order.customer}}))"
                        },
                        {
                          "value": "invoice",
                          "text": "Invoice#", "type": "url",
                          "url": "/invoice/{{__item.invoice}}"
                        },
                        {
                          "value": "__item.typeOfDelivery",
                          "text": "Type of Delivery"
                        },
                        {
                          "value": "__item.driverName",
                          "text": "Driver Name"
                        },
                        {
                          "value": "__item.plateNumber",
                          "text": "Plate No."
                        },
                        {
                          "value": "trackingNo",
                          "text": "Tracking No"
                         }
                      ],
                      "tableType": "static",
                      "selectableUniqueId": "_id",
                      "groupActions": [
                        {
                          "label": "Mark As Dispatched",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "copySelectedLoadingManifest"
                            },
                            {
                              "executionOrder": 2,
                              "pageFunction": {
                                "name": "copyLmDispatchDetails",
                                "type": "fnCopyData",
                                "arg1Key": "sourceFn",
                                "arg1Value": "getLmDispatchDetails",
                                "arg2Key": "destinationKey",
                                "arg2Value": "formData",
                                "arg3Key": "destinationKeyType",
                                "arg3Value": "Object",
                                "arg4Key": "append",
                                "arg4Value": "TRUE"
                              },
                              "name": "copyLmDispatchDetails"
                            },
                            {
                              "executionOrder": 3,
                              "name": "openDispatchPopup",
                              "pageFunction": {
                                "name": "openDispatchPopup",
                                "type": "fnOpenPopup",
                                "arg1Key": "popupName",
                                "arg1Value": "Mark As Dispatched"
                              }
                            }
                          ]
                        }
                      ],
                      "singleSelect": true,
                      "neverHideActionBar": true,
                      "pagination": {
                        "pageVariable": "fetchedData.invoicedLmForm.page",
                        "serverItemsLengthVariable": "fetchedData.invoicedLms.data.totalDocs",
                        "pageChangeFns": [
                          {
                            "executionOrder": 2,
                            "name": "getInvoicedLms"
                          }
                        ],
                        "itemsPerPageVariable": "fetchedData.invoicedLmForm.limit"
                      }
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "Dispatched",
              "bracketValueFormula": "{{fetchedData.dispatchedLms.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Dispatched Loading Manifests",
                      "disabled": "FALSE",
                      "items": "fetchedData.dispatchedLms.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "LM#",
                          "type": "url",
                          "url": "/loading-manifest/{{__item._id}}"
                        },
                        {
                          "value": "__item.createdAt",
                          "text": "LM Date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.createdAt}})"
                        },
                        {
                          "value": "orders.0.factoryTicket.order.customer",
                          "text": "Customer",
                          "formula": "fn(HELPER_FN,customerAlias,fn(CONDITIONAL,fn(NOT,{{__item.orders.0.factoryTicket.order.customer}}),{{__item.callOffs.0.callOff.customer}},{{__item.orders.0.factoryTicket.order.customer}}))"
                        },
                        {
                          "value": "invoice",
                          "text": "Invoice#", "type": "url",
                          "url": "/invoice/{{__item.invoice}}"
                        },
                        {
                          "value": "__item.typeOfDelivery",
                          "text": "Type of Delivery"
                        },
                        {
                          "value": "__item.driverName",
                          "text": "Driver Name"
                        },
                        {
                          "value": "__item.plateNumber",
                          "text": "Plate No."
                        },
                        {
                          "value": "trackingNo",
                          "text": "Tracking No"
                         }
                      ],
                      "tableType": "static",
                      "selectableUniqueId": "_id",
                      "groupActions": [
                        {
                          "label": "Mark As Delivered",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "copySelectedLoadingManifest"
                            },
                            {
                              "executionOrder": 2,
                              "pageFunction": {
                                "name": "openDeliveryPopup",
                                "type": "fnOpenPopup",
                                "arg1Key": "popupName",
                                "arg1Value": "Mark As Delivered"
                              },
                              "name": "openDeliveryPopup"
                            }
                          ]
                        }
                      ],
                      "singleSelect": true,
                      "neverHideActionBar": true,
                      "pagination": {
                        "pageVariable": "fetchedData.dispatchedLmForm.page",
                        "serverItemsLengthVariable": "fetchedData.dispatchedLms.data.totalDocs",
                        "pageChangeFns": [
                          {
                            "executionOrder": 2,
                            "name": "getDispatchedLms"
                          }
                        ],
                        "itemsPerPageVariable": "fetchedData.dispatchedLmForm.limit"
                      }
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "Delivered",
              "bracketValueFormula": "{{fetchedData.deliveredLms.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Delivered Loading Manifests",
                      "disabled": "FALSE",
                      "items": "fetchedData.deliveredLms.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "LM#",
                          "type": "url",
                          "url": "/loading-manifest/{{__item._id}}"
                        },
                        {
                          "value": "__item.createdAt",
                          "text": "LM Date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.createdAt}})"
                        },
                        {
                          "value": "orders.0.factoryTicket.order.customer",
                          "text": "Customer",
                          "formula": "fn(HELPER_FN,customerAlias,fn(CONDITIONAL,fn(NOT,{{__item.orders.0.factoryTicket.order.customer}}),{{__item.callOffs.0.callOff.customer}},{{__item.orders.0.factoryTicket.order.customer}}))"
                        },
                        {
                          "value": "invoice",
                          "text": "Invoice#", "type": "url",
                          "url": "/invoice/{{__item.invoice}}"
                        },
                        {
                          "value": "__item.typeOfDelivery",
                          "text": "Type of Delivery"
                        },
                        {
                          "value": "__item.driverName",
                          "text": "Driver Name"
                        },
                        {
                          "value": "__item.plateNumber",
                          "text": "Plate No."
                        },
                        {
                          "value": "trackingNo",
                          "text": "Tracking No"
                        },
                        {
                          "value": "__item.deliveredAt",
                          "text": "Delivery Date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.deliveredAt}})"
                        }
                      ],
                      "tableType": "static",
                      "neverHideActionBar": true,
                      "pagination": {
                        "pageVariable": "fetchedData.deliveredLmForm.page",
                        "serverItemsLengthVariable": "fetchedData.deliveredLms.data.totalDocs",
                        "pageChangeFns": [
                          {
                            "executionOrder": 2,
                            "name": "getDeliveredLms"
                          }
                        ],
                        "itemsPerPageVariable": "fetchedData.deliveredLmForm.limit"
                      }
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "type": "popupGroup",
          "label": "Mark As Dispatched",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.typeOfDelivery",
                  "label": "Type of Delivery",
                  "disabled": "FALSE",
                  "items": "[\"Senddex\",\"Aramex\",\"Naqel\",\"Smsa\",\"Company Driver\",\"Third Party\",\"Customer Pickup\"]",
                  "dropdownType": "static"
                },
                {
                  "type": "input",
                  "variable": "formData.trackingNo",
                  "label": "Tracking No",
                  "disabled": "FALSE"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.driverName",
                  "label": "Driver Name",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.plateNumber",
                  "label": "Plate Number",
                  "disabled": "FALSE"
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Mark As Dispatched",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "markLmAsDispatched",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/loadingmanifest/{{fetchedData.selectedLoadingManifest._id}}/mark-dispatched",
                    "arg2Key": "postData",
                    "arg2Value": "formData",
                    "arg3Key": "refreshPage",
                    "arg3Value": "TRUE",
                    "arg4Key": "requestMethod",
                    "arg4Value": "PATCH"
                  },
                  "name": "markLmAsDispatched"
                },
                {
                  "executionOrder": 2,
                  "name": "closeDispatchPopup",
                  "pageFunction": {
                    "name": "closeDispatchPopup",
                    "type": "fnClosePopup",
                    "arg1Key": "popupName",
                    "arg1Value": "Mark As Dispatched"
                  }
                }
              ]
            }
          ]
        },
        {
          "type": "popupGroup",
          "label": "Mark As Delivered",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "arrayGroup",
                  "variable": "formData.proofOfDelivery",
                  "disabled": "FALSE",
                  "arrayItems": [
                    {
                      "name": "1",
                      "pageItems": [
                        {
                          "type": "fileupload",
                          "variable": "picture",
                          "label": "Proof Of Delivery",
                          "disabled": "FALSE",
                          "color": "primary",
                          "previewType": "no-preview"
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Mark As Delivered",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "markLmAsDelivered",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/loadingmanifest/{{fetchedData.selectedLoadingManifest._id}}/mark-delivered",
                    "arg2Key": "postData",
                    "arg2Value": "formData",
                    "arg3Key": "refreshPage",
                    "arg3Value": "TRUE",
                    "arg4Key": "requestMethod",
                    "arg4Value": "PATCH"
                  },
                  "name": "markLmAsDelivered"
                },
                {
                  "executionOrder": 2,
                  "name": "closeDeliveryPopup",
                  "pageFunction": {
                    "name": "closeDeliveryPopup",
                    "type": "fnClosePopup",
                    "arg1Key": "popupName",
                    "arg1Value": "Mark As Delivered"
                  }
                }
              ]
            }
          ]
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultPendingLmForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultPendingLmForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.pendingLmForm",
          "arg3Key": "destinationKeyType",
          "arg3Value": "Object",
          "arg4Key": "append",
          "arg4Value": "TRUE"
        },
        "name": "copyDefaultPendingLmForm"
      },
      {
        "executionOrder": 2,
        "name": "getPendingLms"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultInvoicedLmForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultInvoicedLmForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.invoicedLmForm",
          "arg3Key": "destinationKeyType",
          "arg3Value": "Object",
          "arg4Key": "append",
          "arg4Value": "TRUE"
        },
        "name": "copyDefaultInvoicedLmForm"
      },
      {
        "executionOrder": 2,
        "name": "getInvoicedLms"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultDispatchedLmForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultDispatchedLmForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.dispatchedLmForm",
          "arg3Key": "destinationKeyType",
          "arg3Value": "Object",
          "arg4Key": "append",
          "arg4Value": "TRUE"
        },
        "name": "copyDefaultDispatchedLmForm"
      },
      {
        "executionOrder": 2,
        "name": "getDispatchedLms"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultDeliveredLmForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultDeliveredLmForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.deliveredLmForm",
          "arg3Key": "destinationKeyType",
          "arg3Value": "Object",
          "arg4Key": "append",
          "arg4Value": "TRUE"
        },
        "name": "copyDefaultDeliveredLmForm"
      },
      {
        "executionOrder": 2,
        "name": "getDeliveredLms"
      }
    ],
    "functions": [
      {
        "name": "getDefaultPageAndLimit",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": "1",
          "limit": "50",
        },
        "useFormula": true
      },
      {
        "name": "getDefaultPendingLmForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "q": {"status": ["Pending"]}
        },
        "staticObject": true
      },
      {
        "name": "getPendingLms",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/loadingmanifest/search",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.pendingLms",
        "arg3Key": "postData",
        "arg3Value": "fetchedData.pendingLmForm"
      },
      {
        "name": "getDefaultInvoicedLmForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "q": {"status": ["Invoiced"]}
        },
        "staticObject": true
      },
      {
        "name": "getInvoicedLms",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/loadingmanifest/search",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.invoicedLms",
        "arg3Key": "postData",
        "arg3Value": "fetchedData.invoicedLmForm"
      },
      {
        "name": "getDefaultDispatchedLmForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "q": {"status": ["Dispatched"]}
        },
        "staticObject": true
      },
      {
        "name": "getDispatchedLms",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/loadingmanifest/search",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.dispatchedLms",
        "arg3Key": "postData",
        "arg3Value": "fetchedData.dispatchedLmForm"
      },
      {
        "name": "getDefaultDeliveredLmForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "q": {"status": ["Delivered"]}
        },
        "staticObject": true
      },
      {
        "name": "getDeliveredLms",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/loadingmanifest/search",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.deliveredLms",
        "arg3Key": "postData",
        "arg3Value": "fetchedData.deliveredLmForm"
      },
      {
        "name": "copySelectedLoadingManifest",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__item",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.selectedLoadingManifest"
      },
      {
        "name": "getLmDispatchDetails",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "typeOfDelivery": "fetchedData.selectedLoadingManifest.typeOfDelivery",
          "trackingNo": "fetchedData.selectedLoadingManifest.trackingNo",
          "driverName": "fetchedData.selectedLoadingManifest.driverName",
          "plateNumber": "fetchedData.selectedLoadingManifest.plateNumber"
        }
      }
    ]
  },
  "forRole": "CUSTOMER_SERVICE_MANAGER,CUSTOMER_SERVICE_OUTBOUND_WAREHOUSE",
  "visible": true
}